import LayoutHR from "layouts/layout-hr";
import React from "react";

const SettlementReportPage = () => {
  return (
    <LayoutHR>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Settlement Report</h3>
              </div>
              <div className="card-body">
                <p>View settlement reports here</p>
                {/* Add settlement report content */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutHR>
  );
};

export default SettlementReportPage;
